const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/sections/fields/EinweisenderArztField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const EinweisenderArztField = generateMetaKatDropDownField(
    '35e92653-3534-41ee-a1d1-4067a701a6f9',
    'EinweisenderArztField'
);
